export const CPT_DESCRIPTIONS: Record<string, string> = {
  "20526": "Injection, carpal tunnel",
  "20550": "Injection, tendon sheath, ligament or aponeurosis",
  "20551": "Injection, single tendon origin or insertion",
  "20604": "Arthrocentesis, small joint, with ultrasound guidance",
  "20606": "Arthrocentesis, intermediate joint, with ultrasound guidance",
  "20611": "Arthrocentesis, major joint, with ultrasound guidance",
  "51798": "Bladder residual urine measurement",
  "64450": "Injection, anesthetic agent, other peripheral nerve or branch",
  "76512": "Ophthalmic ultrasound, B-scan",
  "76529": "Ophthalmic ultrasonic foreign body localization",
  "76536": "Ultrasound, soft tissues of head and neck",
  "76604": "Chest ultrasound",
  "76705": "Abdominal limited ultrasound",
  "76706": "Aortic aneurysm screening",
  "76770": "Retroperitoneal complete ultrasound",
  "76775": "Retroperitoneal limited ultrasound",
  "76815": "Ultrasound, pregnant uterus, limited",
  "76817": "Ultrasound, pregnant uterus, transvaginal",
  "76857": "Pelvic ultrasound, non-obstetric, limited",
  "76870": "Ultrasound, scrotum and contents",
  "76881": "Complete joint ultrasound",
  "76882": "Limited extremity ultrasound, non-vascular",
  "76942": "Ultrasonic guidance for needle placement",
  "93306": "Complete transthoracic echocardiography",
  "93308": "Limited echocardiography follow-up study",
  "93321": "Doppler echocardiography; spectral",
  "93325": "Doppler echocardiography; color flow",
  "93971": "Duplex scan of extremity veins, unilateral or limited",
};
